/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contactsourcepersonid4Inputs */

const de__field_contactsourcepersonid4 = /** @type {(inputs: _Field_Contactsourcepersonid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktquelle ID`)
};

/**

* @param {_Field_Contactsourcepersonid4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_contactsourcepersonid4 = /** @type {((inputs?: _Field_Contactsourcepersonid4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contactsourcepersonid4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_contactsourcepersonid4(inputs)
});
export { _field_contactsourcepersonid4 as "_field_contactSourcePersonID" }